








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BookmarkButton extends Vue {
    // TODO: interface定義して渡したいかもしれない
    @Prop() private href!: string;
    @Prop() private src!: string;
    @Prop() private name!: string;
}
